<template>
  <div class="blankBox">
    <table border="0" cellpadding="0" cellspacing="0" class="selectTb serchFilter" style="padding-left: 0;padding-top: 15px;">
      <tr>
        <td class="td1">
          <!--申请公司-->
          {{ $t('fancingFundList.applyCompany') }}:
        </td>
        <td class="td2">
          <!--请输入内容-->
          <el-input :placeholder="$t('financingFundList.enterPlaceHolder')" v-model.trim="companyName" style="width: 250px;" class="theme-gray" maxlength="50"/>
        </td>
        <td class="td3">
          <!--申请状态：-->
          {{ $t('fancingFundList.tbTr8') }}：
        </td>
        <td class="td4">
          <el-select v-model="statusList" :placeholder="$t('frontPage.pleaseChoose')" class="theme-gray" multiple no-data-text="">
            <!--                <el-option  :label="$t(`capitalList.all`)" value="0" key="0">{{$t(`capitalList.all`)}}</el-option>-->
            <el-option
              v-for="item in statusArr"
              :key="item"
              :label="$t(`allorders_status.${item}`)"
              :value="item"
            />
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="td1">
          {{ $t('financing.startTime')+'：' }}
        </td>
        <td class="td2">
          <el-date-picker v-model="pg_stt" :placeholder="$t('loan.selectTime')" style="width: 250px;background: #F5F6F8;border: none" format="yyyy-MM-dd" class="themDefault" type="date"/>
        </td>
        <td class="td3">
          {{ $t('financing.endTime')+'：' }}

        </td>
        <td class="td4">
          <el-date-picker v-model="pg_et" :placeholder="$t('loan.selectTime')" style="width: 250px;background: #F5F6F8;border: none" format="yyyy-MM-dd" class="themDefault" type="date"/>
        </td>
      </tr>
      <tr>
        <td class="td1">
          <!--流水号-->
          {{ $t('fancingFundList.flowNum') }}：
        </td>
        <td class="td2">
          <el-input :placeholder="$t('financingFundList.enterPlaceHolder')" v-model.trim="flowNumber" style="width: 250px;" class="theme-gray" maxlength="50"/>
        </td>
        <td class="td3"/>
        <td class="td4"/>
      </tr>

    </table>
    <div class="text-center">
      <div style="margin-top:10px;margin-bottom:30px;" class="centerBtn btn-blue" @click="getList(1)">
        <!--查询-->
        {{ $t('btns.query') }}
      </div>
    </div>

    <el-table :data="dataList" class="dataTable">
      <el-table-column :label="$t('contractManage.orderNum')" width="50" align="left">
        <template slot-scope="scope">
          <span>{{ ((page.pageNo-1) * page.rows) + scope.$index+1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.applyDate')" width="125">
        <template slot-scope="scope">{{ scope.row.applyTime | dateConvert }}</template>
      </el-table-column>
      <!--      申请日期-->

      <el-table-column :label="$t('flowLists.flowNumber')" prop="flowNumber" width="160"/>
      <el-table-column :label="$t('loan.applyCompany')" :show-overflow-tooltip="true" prop="companyName" width="170"/>
      <el-table-column :label="$t('financingFundList.applyMoneyTr')" width="150">
        <template slot-scope="scope">{{ scope.row.applyMoneyType }} {{ scope.row.applyMoney | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('poolOfMoney_page.lockMoney')+'(US$)'" width="165">
        <template slot-scope="scope">
          <!--          {{scope.row.lockMoneyType}}-->
          {{ scope.row.lockMoney | formatNum }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('fancingFundList.tbTr6')" width="185">
        <template slot-scope="scope">{{ scope.row.estimateStartDate | dateConvert }}</template>
      </el-table-column>
      <el-table-column :label="$t('fancingFundList.tbTr7')" width="180">
        <template slot-scope="scope">{{ scope.row.estimateEndDate | dateConvert }}</template>
      </el-table-column>

      <!-- 申请状态 -->
      <el-table-column :label="$t('loan.status')" width="165" align="left" fixed="right">
        <template slot-scope="scope">
          {{ $t(`allorders_status.${scope.row.applicationStatus}`) }}
        </template>
      </el-table-column>
      <!-- 功能 -->
      <el-table-column :label="$t('contractManage.function')" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <router-link v-if="hasRight(scope.row.applicationStatus)&&isApply(scope.row.applicationStatus)" :to="{ name: 'financingFundDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.apply') }}</router-link>
          <router-link v-else-if="hasRight(scope.row.applicationStatus)&&isAudit(scope.row.applicationStatus)" :to="{ name: 'financingFundDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.audit') }}</router-link>
          <router-link v-else :to="{ name: 'financingFundDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.view') }}</router-link>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="statusEmpty"><i/>{{ $t('financing.noData') }}</div>
      </template>
    </el-table>

    <el-pagination
      v-show="page.total"
      :total="page.total"
      :page-size="page.rows"
      :current-page.sync="page.pageNo"
      class="page-theme"
      background
      layout="prev, pager, next"
      style="text-align: center;padding-top:30px; padding-bottom: 30px; "
      @current-change="getList(page.pageNo)"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '@/helper/mixins.js'
import dayjs from 'dayjs'
export default {
  name: 'FinancingFundList',
  components: {},
  mixins: [mixins],
  data() {
    return {
      statusArr: [0, 8, 10, 11, 12, 300, 13, 14],
      // statusData:{},
      thisTime: '',
      timeArr: [],
      companyName: '',
      flowNumber: '',
      btnLimit: [], // 按钮权限集合
      statusList: [], // 状态
      pg_stt: dayjs(dayjs().subtract(12, 'month').format('YYYY-MM-DD') + ' 00:00:00').toDate(), // 开始时间
      pg_et: dayjs(dayjs().format('YYYY-MM-DD') + ' 23:59:59').toDate(), // 结束时间

      dataList: [],
      page: {
        pageNo: 1, // 当前页数
        rows: 10,
        total: 0
      } // 分页数据
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  mounted() {
    this.$nextTick(function() {
      const userProfile = parseInt(this.$utils.getStorage('userProfile').isSuper)
      if (userProfile) { // 如果是超级管理员 所有的权限都会有
        this.btnLimit = [1, 10, 11, 12]
      } else {
        this.getMenuLimit(2).then(data => {
          // console.log('getMenuLimit',data)
          this.btnLimit = data
        }) // 获取贷后跟踪下的操作按钮权限
      }
      // this.getdiscList();
      document.title = this.$t('financingFundList.tittle')
      // const end = new Date(new Date(new Date().toDateString()).getTime()+24*60*60*1000-1);
      // const start = new Date(new Date(new Date().toDateString()).getTime() - 3600 * 1000 * 24 * 30);
      this.thisTime = new Date()
      this.getList(1)
    })
  },
  methods: {
    // 列表查询
    getList: function(pageNo) {
      this.page.pageNo = pageNo
      const params = {
        companyName: this.companyName,
        statusList: this.statusList.indexOf(0) > -1 || this.statusList.length < 1 ? '' : this.statusList.toString(),
        flowNumber: this.flowNumber,
        page: pageNo,
        rows: 10
      }
      if (this.pg_stt) {
        params.startTime = this.pg_stt.toString()
      }
      if (this.pg_et) {
        params.endTime = dayjs(dayjs(this.pg_et).format('YYYY-MM-DD') + '23:59:59').toDate().toString()
      }
      this.axios.post('/capital/getCapitalPage', params)
        .then(res => {
          if (res.status) {
            this.page.total = res.data.total
            this.dataList = res.data.rows
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`))
          }
        })
    },
    /* 是否展示查看
      8: "zma_risk_through_1"  风控通过
      10: "zma_capitalLock_audit_1" 资金锁定审核中
      11: "zma_first_capitalLock_audit_1"锁定一审中
      12: "zma_second_capitalLock_audit_1"锁定二审中
      13: "zma_capitalLock_refuse_1" 锁定拒绝
      14: "zma_capitalLock_close_1" 锁定关闭
      */
    hasRight(status) {
      status = parseInt(status)
      if (this.btnLimit.indexOf(status) > -1) {
        return true
      } else {
        return false
      }
    },
    // 是否展示申请
    isApply(status) {
      status = parseInt(status)
      if (status === 10) {
        return true
      } else {
        return false
      }
    },
    // 是否展示审核
    isAudit(status) {
      status = parseInt(status)
      if (status === 11 || status === 12) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .serchFilter .el-input__inner {
    background: #F5F6F8;
    border-radius: 2px;
    font-size: 14px;
    border: #f89d46;
    height: 36px;
    line-height: 36px;
  }
  .formSelect {
    padding: 23px 28px 21px;
  }
  .pr10 {
    padding-right: 10px;
  }

  .formSelect {
    font-size: 14px;
    color: #333333;
  }

  .selectTb{
    table-layout:fixed;
    td{
      font-size: 14px;
      color: #333333;
      padding:10px 30px;
      &.td2{
        padding-right: 10px;
        padding-left: 0;
      }
      &.td4{
        padding-left: 0;
      }
    }
  }

</style>

